import script from "./FileUpload.vue?vue&type=script&setup=true&lang=ts"
export * from "./FileUpload.vue?vue&type=script&setup=true&lang=ts"

import "./FileUpload.vue?vue&type=style&index=0&id=514ed778&scoped=true&lang=less"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-514ed778"]])

export default __exports__